export default __webpack_public_path__ + "static/media/cinq.db51e016.jpg";